import React from 'react';
import { motion } from 'framer-motion';
interface WelcomeScreenProps {
  onNext: () => void;
}
const FLOATING_DONUTS = [{
  emoji: '🍩',
  x: '8%',
  y: '12%',
  size: 'text-4xl',
  delay: 0
}, {
  emoji: '🧁',
  x: '82%',
  y: '18%',
  size: 'text-3xl',
  delay: 0.5
}, {
  emoji: '🍩',
  x: '88%',
  y: '62%',
  size: 'text-5xl',
  delay: 1
}, {
  emoji: '🎂',
  x: '6%',
  y: '70%',
  size: 'text-3xl',
  delay: 0.8
}, {
  emoji: '✨',
  x: '50%',
  y: '8%',
  size: 'text-2xl',
  delay: 0.3
}, {
  emoji: '✨',
  x: '20%',
  y: '45%',
  size: 'text-xl',
  delay: 1.2
}];
export function WelcomeScreen({
  onNext
}: WelcomeScreenProps) {
  return <div className="flex flex-col min-h-screen relative bg-gradient-to-b from-rose-100 via-pink-50 to-amber-50 overflow-hidden" data-id="element-148">
      {/* Decorative blobs */}
      <div className="absolute -top-24 -left-24 w-72 h-72 bg-rose-300/40 rounded-full blur-3xl pointer-events-none" data-id="element-149" />
      <div className="absolute -bottom-24 -right-16 w-80 h-80 bg-amber-300/40 rounded-full blur-3xl pointer-events-none" data-id="element-150" />
      <div className="absolute top-1/3 right-1/4 w-40 h-40 bg-pink-300/30 rounded-full blur-3xl pointer-events-none" data-id="element-151" />

      {/* Floating donuts */}
      {FLOATING_DONUTS.map((d, i) => <motion.div key={i} className={`absolute ${d.size} pointer-events-none select-none drop-shadow-lg`} style={{
      left: d.x,
      top: d.y
    }} initial={{
      opacity: 0,
      scale: 0
    }} animate={{
      opacity: 1,
      scale: 1,
      y: [0, -12, 0],
      rotate: [0, 8, -8, 0]
    }} transition={{
      opacity: {
        duration: 0.6,
        delay: d.delay
      },
      scale: {
        duration: 0.6,
        delay: d.delay,
        type: 'spring'
      },
      y: {
        duration: 4,
        repeat: Infinity,
        delay: d.delay,
        ease: 'easeInOut'
      },
      rotate: {
        duration: 6,
        repeat: Infinity,
        delay: d.delay,
        ease: 'easeInOut'
      }
    }} data-id="element-152">
          {d.emoji}
        </motion.div>)}

      <div className="relative z-10 flex flex-col items-center justify-center flex-grow px-6 py-12 text-center max-w-md mx-auto w-full" data-id="element-153">
        {/* Brand pill */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="mb-7 inline-flex items-center gap-2 px-4 py-1.5 bg-white border border-rose-200 rounded-full shadow-sm" data-id="element-154">
          <span className="w-2 h-2 rounded-full bg-rose-500 animate-pulse" data-id="element-155" />
          <span className="text-[11px] font-extrabold tracking-[0.18em] uppercase text-rose-700" data-id="element-156">
            Test Gratuito · 60 segundos
          </span>
        </motion.div>

        {/* Hero donut */}
        <motion.div initial={{
        scale: 0,
        rotate: -20
      }} animate={{
        scale: 1,
        rotate: 0
      }} transition={{
        type: 'spring',
        stiffness: 180,
        damping: 14,
        delay: 0.1
      }} className="mb-6 relative" data-id="element-157">
          <div className="absolute inset-0 bg-rose-400/40 blur-2xl rounded-full" data-id="element-158" />
          <div className="relative text-[88px] leading-none drop-shadow-[0_10px_25px_rgba(244,63,94,0.35)]" data-id="element-159">
            🍩
          </div>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45,
        delay: 0.2
      }} className="font-display font-black leading-[1.05] mb-5 text-rose-950 text-[34px] tracking-tight" data-id="element-160">
          ¿Tenés lo que se necesita para este 2026?
        </motion.h2>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.35
      }} className="text-base text-rose-900/75 mb-10 font-medium leading-relaxed max-w-sm" data-id="element-161">
          Respondé estas{' '}
          <span className="font-bold text-rose-700" data-id="element-162">5 preguntas rápidas</span> y
          descubrí tu potencial emprendedor.{' '}
          <span className="font-bold" data-id="element-163">¡Hay una sorpresa al final! 🎁</span>
        </motion.p>

        <motion.button initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        delay: 0.5
      }} onClick={onNext} whileTap={{
        scale: 0.97
      }} className="group w-full bg-gradient-to-r from-rose-500 via-pink-500 to-rose-500 hover:from-rose-600 hover:to-pink-600 text-white font-extrabold text-base py-5 px-6 rounded-2xl shadow-[0_12px_32px_-8px_rgba(244,63,94,0.6)] transition-all hover:shadow-[0_18px_40px_-8px_rgba(244,63,94,0.7)] hover:-translate-y-0.5 flex items-center justify-center gap-2 tracking-wide" data-id="element-164">
          <span data-id="element-165">¡QUIERO DESCUBRIR MI PERFIL!</span>
          <motion.span animate={{
          x: [0, 6, 0]
        }} transition={{
          duration: 1.4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-166">
            →
          </motion.span>
        </motion.button>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.7
      }} className="mt-6 flex items-center justify-center gap-1.5 text-[11px] font-semibold text-rose-900/60" data-id="element-167">
          <span data-id="element-168">🔒</span>
          <span data-id="element-169">100% gratis · sin email · sin compromiso</span>
        </motion.div>
      </div>
    </div>;
}